module.exports = __webpack_public_path__ + "static/img_4491-4402d5cfc5cc99346bfa133f99b14b10.webp";